/**
 * Video Block JavaScript
 *
 * @package TekCreative
 * @since 2.0.0
 */

(function() {
    'use strict';

    const OneColVideo001 = {
        selector: '[data-video-block]',

        init() {
            const blocks = document.querySelectorAll(this.selector);
            if (!blocks.length) return;

            blocks.forEach(block => this.initBlock(block));
        },

        initBlock(block) {
            if (block.dataset.initialized === 'true') return;
            block.dataset.initialized = 'true';

            const mode = block.dataset.openMode; // 'popup' or 'inside'
            const trigger = block.querySelector('[data-video-trigger]');

            if (mode === 'inside') {
                const videoWrap = block.querySelector('.one-col-video-001__video-wrap');
                const video = block.querySelector('.one-col-video-001__player');

                if (trigger && videoWrap && video) {
                    trigger.addEventListener('click', (e) => {
                        e.preventDefault();
                        trigger.style.display = 'none';
                        videoWrap.style.display = 'block';
                        video.play().catch(() => {});
                    });
                }
            } else if (mode === 'popup') {
                const blockId = block.id;
                if (!blockId) return;

                const modalId = 'video-modal-' + blockId;
                const modal = document.getElementById(modalId);
                if (!modal) return;

                const modalVideo = modal.querySelector('video');
                if (!modalVideo) return;

                // Watch for modal visibility changes to play/pause video
                const observer = new MutationObserver(() => {
                    const isOpen = modal.classList.contains('is-open') || modal.getAttribute('aria-hidden') === 'false';
                    if (isOpen) {
                        modalVideo.play().catch(() => {});
                    } else {
                        modalVideo.pause();
                    }
                });

                observer.observe(modal, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
            }
        },
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => OneColVideo001.init());
    } else {
        OneColVideo001.init();
    }

    // Re-initialize for Gutenberg editor preview
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=one-col-video-001', () => {
            setTimeout(() => OneColVideo001.init(), 100);
        });
    }

})();
